import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StoreService } from '../services/store.service';
import { NavService } from '../services/nav.service';

@Injectable({
  providedIn: 'root'
})
export class CandoGuard implements CanActivate {
  constructor(private router: Router, private settings: StoreService, private navService: NavService) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let droit = (route.data.meta && route.data.meta['can']) || null;
    console.log('CAN ACTIONS::: ' + droit + ' : ' + route.url, this.settings.tmp.actions);
    if (droit === null) {
      return true;
    }
    const hasPermission = () => {
      let r = false;
      if (!Array.isArray(droit)) {
        droit = [droit];
      }
      console.log('CAN Droit ', droit);
      if (!this.settings.tmp.actions) {
        this.router.navigate(['/']);
        return false;
      }
      droit.forEach(d => r = r || this.settings.tmp.actions.includes(d));
      return r;
    };
    if (!hasPermission()) {
      this.navService.redirectUrl = state.url;
      this.router.navigate(['/403']);
      return false;
    }
    return true;
  }

}
